/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ValueErrorDirective } from '../../directive/value-error.directive';

@Component({
  selector: 'kit-value-error',
  templateUrl: './value-error.component.html',
  styleUrls: ['./value-error.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ValueErrorComponent extends ValueErrorDirective { }
